import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { images } from '../mock';

const posts = [
  { title: 'How to take card payments without a card reader', cat: 'Tap to Pay', img: images.contactless, read: '4 min read' },
  { title: '5 ways payment links can grow your side hustle', cat: 'Payment Links', img: images.vendor, read: '6 min read' },
  { title: 'Why instant payouts matter when you\u2019re starting out', cat: 'Money', img: images.paySuccess, read: '3 min read' },
  { title: 'Launch a storefront that actually sells in minutes', cat: 'Storefront', img: images.florist2, read: '5 min read' },
  { title: 'Finding local markets to sell at this weekend', cat: 'Growth', img: images.hero, read: '7 min read' },
  { title: 'A simple guide to contactless payments in 2025', cat: 'Guides', img: images.cafe, read: '8 min read' },
];

const Blog = () => {
  return (
    <div className="bg-white pt-40 pb-24 px-6 min-h-screen">
      <div className="max-w-6xl mx-auto">
        <p className="text-sm font-semibold text-[#0e9f6e] text-center mb-3">Blog</p>
        <h1 className="font-display text-5xl sm:text-6xl font-700 text-[#0f1712] text-center">Ideas to help you sell more.</h1>
        <p className="text-[#0f1712]/55 text-center max-w-xl mx-auto mt-5">Tips, guides and stories from sellers using FLIX every day.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {posts.map((p, i) => (
            <article key={i} className="group cursor-pointer">
              <div className="overflow-hidden rounded-3xl aspect-[16/10] mb-5 bg-[#f6f6f2]">
                <img src={p.img} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="flex items-center gap-3 mb-2">
                <span className="text-xs font-semibold uppercase tracking-wide text-[#0e9f6e]">{p.cat}</span>
                <span className="text-xs text-[#0f1712]/40">{p.read}</span>
              </div>
              <h3 className="font-display text-xl font-600 text-[#0f1712] leading-snug flex items-start gap-1 group-hover:text-[#0e9f6e] transition-colors">
                {p.title}
                <ArrowUpRight size={18} className="shrink-0 mt-1 opacity-0 group-hover:opacity-100 transition-opacity" />
              </h3>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
